.liveNotesPanel {
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	height: 62vh;
	border: 1px solid #e6e0e9;
	border-radius: 10px;
}

.liveNotesContent {
	display: flex;
	flex-basis: 100%;
	overflow: auto;
	justify-content: center;
}

.liveBarContentNotes {
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 2px;
	flex-grow: 1;
}
